import BookSpacer from './bookSpacer'

$('.js__bookSpacer').each((_, el) => {
  const $el = $(el)

  $el.reactify(BookSpacer, $el.data())
  $el.children().unwrap()
})
